import { useMemo } from 'react';
import type { AuthUser } from '@/core/auth/types';
import type { HistoryItem } from '../components/MatchmakingHistoryPopover';

type UseMatchmakingPropsParams = {
  loggedInUser: AuthUser | null;
  selectedClient: { avatar?: string } | null;
  clientProfile: any;
  ageDisplay: string;
  matchingPrompt: string;
  selectedZipCode: string;
  selectedState: string;
  selectedCounty: string;
  selectedAddress: string;
  lastHistoryItemRef: React.MutableRefObject<HistoryItem | null>;
};

export const useMatchmakingProps = ({
  loggedInUser,
  selectedClient,
  ageDisplay,
  matchingPrompt,
  selectedZipCode,
  selectedState,
  selectedCounty,
  selectedAddress,
  lastHistoryItemRef,
}: UseMatchmakingPropsParams) => {
  const advisorEmail = useMemo(
    () => loggedInUser?.email || '',
    [loggedInUser?.email],
  );

  const advisorName = useMemo(() => {
    if (loggedInUser?.firstName && loggedInUser?.lastName) {
      return `${loggedInUser.firstName} ${loggedInUser.lastName}`;
    }
    return loggedInUser?.firstName || loggedInUser?.lastName || '';
  }, [loggedInUser?.firstName, loggedInUser?.lastName]);

  const clientAvatar = useMemo(() => selectedClient?.avatar, [selectedClient?.avatar]);

  const modalProps = useMemo(
    () => ({
      clientAvatar,
      ageDisplay,
      advisorEmail,
      advisorName,
      searchQuery: matchingPrompt,
      locationZipCode: selectedZipCode,
      locationState: selectedState,
      locationCounty: selectedCounty,
      locationAddress: selectedAddress,
      historyItem: lastHistoryItemRef.current,
    }),
    [
      clientAvatar,
      ageDisplay,
      advisorEmail,
      advisorName,
      matchingPrompt,
      selectedZipCode,
      selectedState,
      selectedCounty,
      selectedAddress,
      lastHistoryItemRef,
    ],
  );

  return {
    advisorEmail,
    advisorName,
    clientAvatar,
    modalProps,
  };
};

